module.exports = __webpack_public_path__ + "static/media/icon_edit.cf2422f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_edit.svg
// module id = 1064
// module chunks = 0